import React, { useCallback,useContext } from 'react'
import { useLocation } from 'react-router-dom'

import cx from 'classnames'

import RightSidebar from 'components/RightSidebar'
import { Card,OpenedSidebar, SidebarOpenContext } from 'context/sidebarOpenContext'
import { useAccountCompanyTitle } from 'hooks/useAccountCompanyTitle'

import CompanyCard, { CompanyCardHeader } from './CompanyCard'
import { ExplainSidebarCard, ExplainSidebarCardHeader } from './ExplainCard'
import { SFDCCard, SFDCHeader } from './SFDCCard'

import styles from './styles.module.css'

interface ExpandableSectionProps {
  expanded: boolean
  renderSectionHeader: ({
    expandable,
    expanded
  }: {
    expandable: boolean
    expanded: boolean
  }) => React.ReactElement
  children: React.ReactElement
  onClick: () => void
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  expanded,
  renderSectionHeader,
  children,
  onClick
}) => {
  return (
    <div className={styles.expandableSection}>
      <div className={styles.expandableSectionHeader} onClick={onClick}>
        {renderSectionHeader({ expandable: true, expanded })}
      </div>
      <div className={cx(styles.expandableContent, { [styles.expanded]: expanded })}>
        {expanded && children}
      </div>
      <div className={styles.bottomSectionBorder}></div>
    </div>
  )
}

const DetailsSidebar: React.FC = () => {
  const { setOpenedRightSidebar, expandedCard, setExpandedCard } = useContext(SidebarOpenContext)

  const location = useLocation()
  const { companyName } = useAccountCompanyTitle()

  const title = companyName || (location.pathname.includes('activity') ? 'Activity' : 'Accounts')

  const toggleExpandedCard = useCallback(
    (card: Card) => {
      if (expandedCard === card) {
        setExpandedCard(Card.NONE)
      } else {
        setExpandedCard(card)
      }
    },
    [expandedCard, setExpandedCard]
  )

  return (
    <RightSidebar
      header={'Account details'}
      subHeader={title}
      onCollapse={() => {
        setOpenedRightSidebar(OpenedSidebar.NONE)
      }}>
      <div className={styles.detailsSidebarContentContainer}>
        <ExpandableSection
          renderSectionHeader={props => <CompanyCardHeader {...props} />}
          expanded={expandedCard === Card.COMPANY_CARD}
          onClick={() => toggleExpandedCard(Card.COMPANY_CARD)}>
          <CompanyCard />
        </ExpandableSection>
        <ExpandableSection
          renderSectionHeader={props => <SFDCHeader {...props} />}
          expanded={expandedCard === Card.SALESFORCE_CARD}
          onClick={() => toggleExpandedCard(Card.SALESFORCE_CARD)}>
          <SFDCCard />
        </ExpandableSection>
        <ExpandableSection
          renderSectionHeader={props => <ExplainSidebarCardHeader {...props} />}
          expanded={expandedCard === Card.EXPLAIN_CARD}
          onClick={() => toggleExpandedCard(Card.EXPLAIN_CARD)}>
          <ExplainSidebarCard />
        </ExpandableSection>
      </div>
    </RightSidebar>
  )
}

export default DetailsSidebar
